"use strict";

define('model/setting',['backbone', 'underscore', './base', '../collection/base', './setting.choice', 'moment'], function (Backbone, _, BaseModel, BaseCollection, SettingChoice, Moment) {
  var validators = Backbone.Validation.validators;
  var Setting = BaseModel.extend({
    urlRoot: '/rs/api/prop',
    idAttribute: 'name',
    childModels: {
      choices: SettingChoice
    },
    validation: function validation() {
      var validations = [];
      switch (this.get('name')) {
        case 'IRB.STUDY_LABEL_PREFIX':
          validations.push({
            minLength: 1
          });
          validations.push({
            maxLength: 30
          });
          break;
        case 'IRB.NOTIFICATION_FROM':
          validations.push({
            pattern: 'email',
            msg: 'Please enter a valid email'
          });
          break;
      }
      switch (this.get('type')) {
        case 'String':
          validations.push({
            maxLength: 100,
            msg: 'Cannot be longer than 100 characters'
          });
          break;
        case 'Integer':
          validations.push({
            min: 0,
            msg: 'Cannot be a negative number'
          });
          validations.push({
            max: 1000,
            msg: 'Cannot be greater than 1,000'
          });
          break;
      }
      return {
        value: validations
      };
    },
    defaults: function defaults() {
      return {
        choices: []
      };
    },
    parse: function parse() {
      var data = BaseModel.prototype.parse.apply(this, arguments);
      return Setting.parseDataValue(data);
    },
    collectionParse: function collectionParse() {
      var list = BaseModel.prototype.collectionParse.apply(this, arguments);
      var fiscalMonthData = _.findWhere(list, {
        type: Setting.FYE_MONTH
      });
      if (fiscalMonthData) {
        var allTheMonths = Moment.months();
        fiscalMonthData.choices = _.map(allTheMonths, function (m) {
          return {
            displayName: m,
            description: allTheMonths.indexOf(m) + 1
          };
        });
      }
      var timezoneSetting = _.findWhere(list, {
        name: Setting.TIMEZONE
      });
      if (timezoneSetting) {
        var choices = timezoneSetting.choices;
        choices.sort(function (a, b) {
          return a.sort < b.sort ? -1 : 1;
        });
      }
      return _.map(list, function (data) {
        return Setting.parseDataValue(data);
      });
    },
    toJSON: function toJSON() {
      var data = BaseModel.prototype.toJSON.apply(this, arguments);
      data.value = String(data.value);
      return data;
    }
  }, {
    parseDataValue: function parseDataValue(data) {
      switch (data.type) {
        case Setting.BOOLEAN:
          data.value = data.value === 'true' || data.value === "1" ? true : false;
          break;
        case Setting.INTEGER:
          data.value = Number(data.value) || 0;
          break;
        case Setting.FYE_MONTH:
          data.value = parseInt(Moment(data.value).format('MM'));
          break;
      }
      return data;
    },
    all: function all(appNameOrNames) {
      var names, appName, collection;
      if (_.isArray(appNameOrNames)) {
        names = appNameOrNames;
        collection = new SettingCollection(_.map(names, function (name) {
          return Setting.one(name);
        }), {
          model: Setting
        });
        collection.fetch = function () {
          return Promise.join(_.invoke(this.models, 'fetch'));
        };
        return collection;
      }
      appName = appNameOrNames;
      return this.createCollection('/rs/api/prop/list/:appName').params({
        appName: appName
      });
    },
    one: function one(name) {
      return new Setting({
        name: name
      });
    },
    BOOLEAN: 'Boolean',
    INTEGER: 'Integer',
    EMAIL: 'Email',
    FYE_MONTH: 'FiscalYearEndMonth',
    TIMEZONE: 'IRB.TIMEZONE'
  });
  var SettingCollection = BaseCollection.extend({
    model: Setting,
    _onModelEvent: function _onModelEvent(event, model, collection, options) {
      if (event === 'validated') {
        return;
      }
      return BaseCollection.prototype._onModelEvent.apply(this, arguments);
    },
    save: function save(options) {
      options = _.extend({
        validate: true
      }, options);
      var success = options.success,
        invalidAttrs = {},
        isValid = false,
        collection = this;
      options.success = function (resp) {
        collection.set(collection.parse(resp), options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      function _triggerValidated() {
        this.trigger('validated', isValid, this, invalidAttrs);
      }
      ;
      var triggerValidated = _.bind(_.after(this.length, _triggerValidated), this);
      this.each(function (model) {
        model.once('validated', function (modelIsValid, m, attrs) {
          if (_.has(attrs, 'value')) {
            invalidAttrs[m.get('name')] = attrs.value;
          }
          _.defer(triggerValidated);
        }, this);
      }, this);
      isValid = _.chain(this.models).map(function (model) {
        return model._validate({}, options);
      }).all(_.identity).value();
      if (!isValid) {
        return false;
      }
      return Backbone.sync('update', this, _.extend({
        url: Setting.prototype.urlRoot,
        attrs: this.formatForSave()
      }, options));
    },
    formatForSave: function formatForSave() {
      return {
        properties: this.map(function (model) {
          return _.pick(model.toJSON(), 'id', 'value');
        })
      };
    }
  });
  Setting.Collection = SettingCollection;
  return Setting;
});

